var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"title":"Склады","breadcrumbs":_vm.breadcrumbs,"custom-headers":_vm.headers,"data-source":_vm.dataSource},scopedSlots:_vm._u([{key:"isDefault",fn:function({ item }){return [_c('v-switch',{attrs:{"input-value":item.isDefault},on:{"change":function($event){return _vm.setDefault(item)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }